import moment from 'moment';
import URL_ROUTE from '../constants/index';

class Api {

    async guardarFormWeb(nombrePersona, apellidoPersona, telefonoPersona, correoPersona, zipCode, comentario, opcionEstado, url, direccionPersona, servicioPersona, lang) {
        let data = {nombrePersona, apellidoPersona, telefonoPersona, correoPersona, zipCode, comentario, opcionEstado, url, direccionPersona, servicioPersona, lang}
        const query = await fetch(`${URL_ROUTE.GUARDARFORMWEB}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query
    }

    async validarRecaptcha(captchaValue) {
        const data = {captchaValue}
        const query = await fetch(`${URL_ROUTE.VALIDARRECAPTCHA}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query
    }
}

export default new Api();
